import socket, { invokeRPC } from './socket.js'

export function getFileSharingProject(projectId) {
  return invokeRPC('fileSharing', 'getFileSharingProject', { project_id: projectId })
}

export function doesCustomerHaveFileSharingProjects(id) {
  const data = { }
  if (id) data.customer_id = id
  return invokeRPC('fileSharing', 'doesCustomerHaveFileSharingProjects', data)
}

export function updateFileSharingProject(data) {
  return invokeRPC('fileSharing', 'updateFileSharingProject', data)
}

export function getFileTreeForProject(data) {
  return invokeRPC('fileSharing', 'getFileTreeForProject', data)
}

export function getFileUploadToken(data) {
  return invokeRPC('fileSharing', 'getFileUploadToken', data)
}

export function deleteFile(prefix) {
  return invokeRPC('fileSharing', 'deleteFile', { prefix })
}

export function renameFile(data) {
  return invokeRPC('fileSharing', 'renameFile', data)
}

export function getNewFolderUploadToken(prefix) {
  return invokeRPC('fileSharing', 'getNewFolderUploadToken', { prefix })
}

export function checkForCustomerRoot(id) {
  return invokeRPC('fileSharing', 'checkForCustomerRoot', { customer_id: id })
}

export function emailFile(data) {
  return invokeRPC('fileSharing', 'emailFile', data)
}
